





/**
 * 
 * @param {function} columns 
 * @param {object} record 
 * @param {object} locationState 
 */
import EditFormatter from 'components/EditFormatter'

export function resolveColumns(columns, record, metaData, locationState) {
  const schema = typeof columns === 'function' ? columns(record, metaData) : columns
  const section = schema && typeof schema === 'object' && schema.section || false
  const sectionColumns = section && locationState && locationState.schemaId && section.find(_ => _.schemaId === locationState.schemaId) || false

  return (sectionColumns && sectionColumns.columns) || (schema && schema.columns) || schema
}

export const dummyData = (fields) => Array.from(Array(10), (x, index) => {
  const columns = fields && fields.length > 0 && fields.reduce((k, el) => Object.assign({}, k, { [el.value]: '' }), {})
  return Object.assign({}, columns, { _id: index + 1, loading: true })
})

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}


export const FormatterFor = {
  actions: EditFormatter
}

export const getStore = async (_id) => await import(`store/${_id}`)


/**
* @param {array} columns 
*/
export function set(columns, formRecord = {}) {
  if (!columns && !formRecord) {
    return false
  }
  let Columns = columns && Object.assign([], columns)
  return Columns.reduce((a, el) => el.defaultValue ? Object.assign({}, a, { [el.value]: el.defaultValue }) : a, formRecord)
}


/**
* 
* @param {integer} bytes 
* @param {integer} decimals 
* @returns 
*/
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export function toDateFunc(leaveDetails) {
  console.log("AXZZ", leaveDetails)

  let Date = []
  var toDateString = leaveDetails.toDate.toLocaleString()
  toDateString = toDateString.split("T")

  var fromDateString = leaveDetails.fromDate.toLocaleString()
  fromDateString = fromDateString.split("T")
  Date.push(...Date, { "toDate": toDateString[0], "fromDate": fromDateString[0] })


  return Date

}
export function fromDateFunc(leaveDetails) {

  let fromDateValue
  var fromDateString = leaveDetails.fromDate.toLocaleString()
  fromDateString = fromDateString.split("T")
  fromDateValue = fromDateString[0]
  return fromDateValue

}
export function commonDateFunc(dateParam) {
  let dateValue
  var dateString = dateParam.toLocaleString()
  dateString = dateString.split("T")
  dateValue = dateString[0]
  return dateValue
}

export const roleIds = ["61bcb7ed0e04359342e992f6"]